import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip } from "chart.js";
import MemoryIcon from '@mui/icons-material/Memory';
import SdStorageIcon from '@mui/icons-material/SdStorage';
import StorageIcon from '@mui/icons-material/Storage';
import { capitalize } from "../../common_functions/video_annotator_functions";
import { Typography } from "@mui/material";
import { capitalizeLabel } from "../../common_functions/video_annotator_functions";

const excemptionFields = ['cpu_percentage', 'disk_free_percentage', 'gpu_vram_percentage', 'ram_percentage'];

let iconsList={
 'cpu_percentage': <MemoryIcon  className="graph-icon" />,
 'disk_free_percentage': <StorageIcon  className="graph-icon" />,
 'gpu_vram_percentage': <SdStorageIcon  className="graph-icon" />,
  'ram_percentage': <SdStorageIcon  className="graph-icon" />
};

Chart.register(ArcElement, Tooltip);

export const PercentageChart = ({ percentage, label }) => {
  const getColor = () => {
    if (percentage > 80) return "#d32f2f"; // Red for high usage
    if (percentage > 50) return "#ffa000"; // Orange for medium usage
    return "#4caf50"; // Green for low usage
  };

  const data = {
    labels: [], // Removed labels to hide other numbers
    datasets: [
      {
        data: [percentage, 100 - percentage],
        backgroundColor: [getColor(), "#e0e0e0"],
        hoverBackgroundColor: [getColor(), "#e0e0e0"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "75%",
    animation: {
      animateRotate: true,
      animateScale: true,
    },
    plugins: {
      tooltip: { enabled: false },
      datalabels: { display: false }, // Disable percentage labels on the graph
    },
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <h4 style={{ fontSize: "1rem", fontWeight: "bold" }}>{capitalizeLabel(label)}</h4>
      <div style={{ width: "140px", height: "140px", position: "relative" }}>
        <Doughnut data={data} options={options} />
        <div style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1rem",
          fontWeight: "bold",
          color: getColor(),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
          {percentage}% 
          <Typography>Used</Typography>
          {iconsList && iconsList[label] && iconsList[label]}
        </div>
      </div>
    </div>
  );
};
